<div class="flex flex-row justify-between">
  <p-breadcrumb
    [model]="[]"
    [home]="home"
  />
</div>
<div class="flex flex-row justify-between pb-2">
  <p-menubar
    class="w-full"
    [model]="this.menuItems"
  >
    <ng-template #end>
      <p-selectbutton
        [options]="filterOptions"
        [(ngModel)]="filterMode"
        (ngModelChange)="this.createTreeNode()"
        [invalid]="filterMode.length == 0"
        [multiple]="true"
        optionLabel="name"
        optionValue="value"
        size="small"
        class="-m-[3px]"
      />
    </ng-template>
  </p-menubar>
</div>
<p-treetable
  #tt
  [value]="this.tasks"
  [scrollable]="true"
  [tableStyle]="{'min-width':'50rem'}"
  [sortMode]="'single'"
>
  <ng-template #header>
    <tr>
      <th style="width:3rem"></th>
      <th
        class="w-[40%]"
        [ttSortableColumn]="'name'"
      >Name <p-treetable-sort-icon field="name" /></th>
      <th
        class="w-[30%]"
        [ttSortableColumn]="'category'"
      >Kategorie <p-treetable-sort-icon field="category" /></th>
      <th
        class="w-[10%]"
        [ttSortableColumn]="'type'"
      >Typ <p-treetable-sort-icon field="type" /></th>
      <th></th>
    </tr>
    <tr>
      <th></th>
      <th>
        <input
          pInputText
          type="text"
          placeholder="Name"
          class="h-8 w-full"
          (input)="tt.filter($any($event.target).value, 'name', 'contains')"
        />
      </th>
      <th>
        <p-select
          [options]="this.categories"
          [(ngModel)]="this.selectedCategory"
          (ngModelChange)="tt.filter(($event ?? ''), 'category', 'equals')"
          [showClear]="true"
          placeholder="Kategorie"
          appendTo="body"
          class="h-8 w-full"
        />
      </th>
      <th>
        <p-select
          [options]="this.types"
          optionLabel="label"
          optionValue="value"
          [(ngModel)]="this.selectedType"
          (ngModelChange)="tt.filter(($event ?? ''), 'type', 'equals')"
          [showClear]="true"
          placeholder="Typ"
          appendTo="body"
          class="h-8 w-full"
        />
      </th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template
    #body
    let-rowNode
    let-rowData="rowData"
  >
    <tr [ttRow]="rowNode">
      <td
        style="width:3rem"
        [ngClass]="{ 'font-bold': rowData.isParent }"
      >
        <p-treetable-toggler [rowNode]="rowNode" />
      </td>
      @if (rowData.isParent) {
      <td
        class="w-[40%] font-bold cursor-pointer"
        (click)="this.toggleParentNode(rowNode)"
      >
        {{ rowData.name }}
      </td>
      }
      @else {
      <td class="w-[40%]">
        <span
          class="underline cursor-pointer me-4"
          (click)="this.onClick(rowData.faId)"
        >
          {{ rowData.name }}
        </span>
        @switch (rowData.state) {
        @case ('draft') {
        <p-tag
          severity="info"
          value="Draft"
          [rounded]="true"
        />
        }
        @case ('live') {
        <p-tag
          severity="success"
          value="Live"
          [rounded]="true"
        />
        }
        @case ('archived') {
        <p-tag
          severity="warn"
          value="Archiviert"
          [rounded]="true"
        />
        }
        }
      </td>
      }
      <td
        class="w-[30%]"
        [ngClass]="{ 'font-bold': rowData.isParent }"
      >
        @if (rowData.isParent) {
        <p-tag
          [value]="rowData.category"
          [rounded]="true"
        />
        }
      </td>
      <td
        class="w-[10%]"
        [ngClass]="{ 'font-bold': rowData.isParent }"
      >
        @if (rowData.isParent) {
        <p-tag
          [value]="rowData.type.toUpperCase()"
          [rounded]="true"
        />
        }
      </td>
      <td>
        @if (!rowData.isParent) {
        <div class="text-right pe-5">
          <i
            class="pi pi-ellipsis-h cursor-pointer"
            (click)="this.onContextMenu($event, rowData.faId)"
          ></i>
          <p-contextmenu
            #cm
            appendTo="body"
          />
        </div>
        }
      </td>
    </tr>
  </ng-template>

</p-treetable>

<p-confirmdialog />

<p-dialog
  header="Fallaufgabe im Status 'Live' bearbeiten"
  [modal]="true"
  [(visible)]="this.isDublicateVisible"
  [closable]="false"
  position="top"
  [draggable]="false"
  [style]="{ width: '40rem' }"
>
  <div>
    <span class="text-base">
      Wollen Sie die aktuelle Live-Fallaufgabe bearbeiten oder ein Dublikat als Draft erzeugen und bearbeiten?
    </span>
    <div class="flex justify-end gap-2 mt-2">
      <p-button
        label="Abbrechen"
        severity="secondary"
        (click)="this.isDublicateVisible = false;"
      />
      <p-button
        label="Draft erzeugen"
        severity="secondary"
        (click)="this.createDublicate()"
      />
      <p-button
        label="Live bearbeiten"
        severity="warn"
        (click)="this.acceptedEdit()"
      />
    </div>
  </div>

</p-dialog>

<p-dialog
  header="Version als neue Fallaufgabe anlegen"
  [modal]="true"
  [(visible)]="this.isCopyVisible"
  [closable]="false"
  position="top"
  [draggable]="false"
  [style]="{ width: '25rem' }"
>
  <div>
    <h3>Bitte bestätigen oder ändern Sie den Namen für die neu zu erstellende Fallaufgabe</h3>
    <input
      type="text"
      class="mt-3"
      [(ngModel)]="this.copyInfo.name"
      pInputText
      fluid
    />
  </div>
  <div class="flex justify-end gap-2 mt-2">
    <p-button
      label="Abbrechen"
      severity="secondary"
      (click)="this.isCopyVisible = false;"
    />
    <p-button
      label="Kopieren"
      severity="success"
      (click)="this.confirmedCopy()"
    />
  </div>
</p-dialog>

<p-dialog
  header="Neue Fallaufgabe erstellen"
  [modal]="true"
  [(visible)]="this.newFallaufgabeFormVisible"
  position="top"
  [draggable]="false"
  [style]="{ width: '25rem' }"
>
  <form
    [formGroup]="this.newFallaufgabenForm"
    (ngSubmit)="this.createFallaufgabe()"
  >
    <div class="mt-3">
      <p-floatlabel variant="on">
        <input
          pInputText
          type="text"
          id="name"
          formControlName="name"
          [invalid]="this.isInvalid('name')"
          fluid
        />
        <label for="name">Name</label>
      </p-floatlabel>
    </div>
    @if (this.isInvalid('name')) {
    <p-message
      severity="error"
      size="small"
      variant="simple"
    >Name ist ein Pflichtfeld.</p-message>
    }
    <div class="mt-3">
      <p-floatlabel variant="on">
        <p-select
          [options]="this.categories"
          [(ngModel)]="this.newFallaufgabeFormCategory"
          [ngModelOptions]="{standalone: true}"
          appendTo="body"
          id="category"
          fluid
        />
        <label for="category">Kategorie</label>
      </p-floatlabel>
    </div>
    <div class="mt-3">
      <p-floatlabel variant="on">
        <p-select
          [options]="this.types"
          [(ngModel)]="this.newFallaufgabeFormType"
          [ngModelOptions]="{standalone: true}"
          appendTo="body"
          id="type"
          fluid
        />
        <label for="type">Typ</label>
      </p-floatlabel>
    </div>
    <div class="flex justify-end gap-2 mt-3">
      <p-button
        severity="secondary"
        label="Abbrechen"
        (click)="this.newFallaufgabeFormVisible = false"
      />
      <p-button
        type="submit"
        label="Weiter"
      />
    </div>
  </form>
</p-dialog>

<p-dialog
  header="Fallaufgabe anlegen"
  [modal]="true"
  [(visible)]="this.isCreateConfirmVisible"
  position="top"
  [draggable]="false"
  [style]="{ width: '25rem' }"
>
  <div class="mt-3">
    <p class="text-sm text-color-secondary m-0">Name</p>
    <p class="mt-1 font-medium">{{ this.newFallaufgabenForm.get('name')?.value }}</p>
  </div>
  <div class="mt-3">
    <p class="text-sm text-color-secondary m-0">Kategorie</p>
    <p class="mt-1 font-medium">{{ this.newFallaufgabeFormCategory }}</p>
  </div>
  <div class="mt-3">
    <p class="text-sm text-color-secondary m-0">Typ</p>
    <p class="mt-1 font-medium">{{ this.newFallaufgabeFormType === 'exam' ? 'Exam' : 'VC' }}</p>
  </div>
  <div class="flex justify-end gap-2 mt-3">
    <p-button
      severity="secondary"
      label="Zurück"
      (click)="this.isCreateConfirmVisible = false; this.newFallaufgabeFormVisible = true"
    />
    <p-button
      label="Anlegen"
      (click)="this.confirmedCreate()"
    />
  </div>
</p-dialog>